import Entity from '../entity'

export default class Region extends Entity<number> {
                   name: string = "";
                   spell: string = "";
                   shortSpell: string = "";
                   icon: string = "";
                   displayOrder: number = 0;
                   parentId: number = 0;
                   layer: number = 0;
                   provinceId: number = 0;
                   provinceName: string = "";
                   cityId: number = 0;
                   cityName: string = "";
                   isAbroad: boolean = false;
                   hasCourt: boolean = false;
                   isHot: boolean |any= false;
                   isHotDisplayOrder: number = 0;
                   isRecommend: boolean | any= false;
                   isRecommendDisplayOrder: number = 0;
                   isPopular: boolean |any = false;
                   isPopularDisplayOrder: number = 0;
                   isTicket: boolean |any = false;
                   isTicketDisplayOrder:number=0;
                   isOnSale:boolean;
                   isPcPreferential:boolean;
               }